export {
  type CachedPathMesh,
  type FillContourGroup,
  pathMeshCache,
  networkMeshCache,
  strokeTriangleChunkCacheByKey,
  fillTriangleChunkCacheByKey,
  unchangedFillChunkCacheByKey,
  maxGeometryCacheEntries,
  maxStrokeChunkCacheEntries,
  maxFillChunkCacheEntries,
  maxUnchangedFillChunkCacheEntries,
  fillChunkGroupThreshold,
  vectorCurveTolerance,
  strokeTriangleChunkPointSize,
} from "./types";

import {
  maxGeometryCacheEntries,
  maxStrokeChunkCacheEntries,
  strokeTriangleChunkCacheByKey,
} from "./types";

export function formatCacheNumber(value: number): string {
  return Number.isInteger(value) ? String(value) : value.toFixed(3);
}

export function setCappedCacheEntry<T>(cache: Map<string, T>, key: string, value: T, maxEntries = maxGeometryCacheEntries): void {
  cache.set(key, value);
  if (cache.size <= maxEntries) {
    return;
  }

  const firstKey = cache.keys().next().value;
  if (firstKey !== undefined) {
    cache.delete(firstKey);
  }
}

/** Internal TS stroke kernel chunk cache — stays number[] (packed at tsPackedBackend boundary). */
export function cachedStrokeTriangleChunk(key: string, compute: () => number[]): number[] {
  if (key !== "uncached") {
    const cached = strokeTriangleChunkCacheByKey.get(key);
    if (cached) {
      return cached;
    }
  }

  const vertices = compute();
  if (key !== "uncached") {
    setCappedCacheEntry(strokeTriangleChunkCacheByKey, key, vertices, maxStrokeChunkCacheEntries);
  }
  return vertices;
}
